import React from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import moment from "moment";

// Semaforización SLA Centro de Atención Zurich (sobre fecha de ingreso al módulo)
// < 30 min  → Verde
// 30–60 min → Amarillo
// > 60 min  → Rojo
const SLA_THRESHOLDS = { warn: 30, danger: 60 };
const SLA_COLORS = {
  ok: "#28a745",
  warn: "#ffc107",
  danger: "#dc3545",
};

const getSlaColor = (referenceDate) => {
  if (!referenceDate) return null;
  const diffMin = moment().diff(moment(referenceDate), "minutes");
  if (diffMin < SLA_THRESHOLDS.warn) return SLA_COLORS.ok;
  if (diffMin < SLA_THRESHOLDS.danger) return SLA_COLORS.warn;
  return SLA_COLORS.danger;
};

const formatDate = (value) =>
  value ? moment.utc(value).format("DD/MM/Y HH:mm:ss A") : "";

const AttentionCenterZurichTable = ({ data, activePage = 1, urlToGo }) => {
  const refresh = () => window.location.reload();

  return (
    <>
      <button onClick={refresh} className="btn btn-primary mb-1 mt-2">
        Actualizar
      </button>

      <Table responsive striped bordered hover className="mt-5">
        <thead>
          <tr>
            <th>Opciones</th>
            <th>SLA Módulo</th>
            <th>Conteo</th>
            <th>Clave</th>
            <th>Folio IH</th>
            <th>Tipo de Trámite</th>
            <th>Folio EP</th>
            <th>Tipo de Ingreso</th>
            <th>Asegurado</th>
            <th>Hospital</th>
            <th>Folio Hospital / Episodio</th>
            <th>Fecha Hora Ingreso (dd/mm/aaaa hh:mm:ss)</th>
            <th>DIAGNÓSTICO Presuntivo</th>
            <th>Fecha Hora Solicitud (dd/mm/aaaa hh:mm:ss)</th>
            <th>Módulo</th>
            <th>Tipo de Póliza</th>
            <th>Fecha / Hora Asignación del Caso (dd/mm/aaaa hh:mm:ss)</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((currCase, i) => {
            const slaColor = getSlaColor(currCase.feaCentroAtencion);
            const folioIhCellStyle = slaColor
              ? {
                  backgroundColor: slaColor,
                  color: "#fff",
                  fontWeight: "bold",
                  textAlign: "center",
                }
              : undefined;

            return (
              <tr key={i}>
                <td>
                  <Link className="btn btn-primary" to={urlToGo + currCase.slug}>
                    Ir
                  </Link>
                </td>
                <td>
                  {slaColor && (
                    <i
                      className="fas fa-flag"
                      style={{ color: slaColor }}
                      title="SLA módulo"
                    ></i>
                  )}
                </td>
                <td>{(activePage - 1) * 20 + i + 1}</td>
                <td>{currCase.caseTicket}</td>
                <td style={folioIhCellStyle}>{currCase.folioIh}</td>
                <td>{currCase.caseType}</td>
                <td>{currCase.atentionIden}</td>
                <td>{currCase.incomeType}</td>
                <td>
                  {`${currCase.assuredName || ""} ${currCase.assuredFlastname || ""} ${currCase.assuredMlastname || ""}`.trim()}
                </td>
                <td>{currCase.hospital?.hospitalName}</td>
                <td>{currCase.hospitalIden}</td>
                <td>{formatDate(currCase.incomeDatetime)}</td>
                <td>{currCase.diagnosis}</td>
                <td>{formatDate(currCase.createdAt)}</td>
                <td>{currCase.status?.descr}</td>
                <td>{currCase.axaCategories}</td>
                <td>{formatDate(currCase.feaCentroAtencion)}</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default AttentionCenterZurichTable;
